export default {
    label_task:{
        en:"Products",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Product",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Product",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of Product",
        bn:'ব্যবহারকারীর বিবরণ'
    },
    label_value:{
        en:"Value(gm)",
        bn:"কর্মচারী আইডি"
    },

}